// /src/components/chat/shared/MessageContainer.js
import React from 'react';
import { Box, Typography, styled } from '@mui/material';

// Styled components to match the original ChatPage.js
const StyledMessageContainer = styled(Box)(({ theme, isBot, messageColor }) => ({
  padding: theme.spacing(2),
  margin: theme.spacing(1),
  maxWidth: '70%',
  backgroundColor: messageColor,
  alignSelf: isBot ? 'flex-start' : 'flex-end',
  borderRadius: '12px',
}));

// Typing dots animation for waiting messages
const TypingDot = styled('span')(({ delay }) => ({
  height: '8px',
  width: '8px',
  margin: '0 2px',
  backgroundColor: '#555',
  borderRadius: '50%',
  display: 'inline-block',
  opacity: 0.4,
  animation: 'pulse 1s infinite',
  animationDelay: delay,
  '@keyframes pulse': {
    '0%': {
      opacity: 0.4,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)',
    },
    '100%': {
      opacity: 0.4,
      transform: 'scale(1)',
    },
  },
}));

const MessageContainer = ({ message, customization, fontSize = 'medium' }) => {
  const isBot = message.isBot;
  const messageColor = isBot ? customization.botMessageColor : customization.userMessageColor;
  const textColor = isBot
    ? (!customization.botTextColor ? '#000000' : customization.botTextColor)
    : (!customization.userTextColor ? '#000000' : customization.userTextColor);
  const isWaiting = message.isWaiting;

  const getFontSize = () => {
    switch (fontSize) {
      case 'large': return '1.1rem';
      case 'x-large': return '1.25rem';
      default: return '0.875rem'; // medium (default)
    }
  };

  const displayBody =
    message.displayText != null && String(message.displayText).trim() !== ''
      ? String(message.displayText)
      : message.text;

  return (
    <StyledMessageContainer
      isBot={isBot}
      messageColor={messageColor}
      elevation={1}
      sx={isWaiting ? { opacity: 0.7, fontStyle: 'italic' } : {}}
    >
      <Typography sx={{ fontSize: getFontSize(), textAlign: 'left', color: textColor, display: 'flex', alignItems: 'center' }}>
        {isBot ? (
          <span dangerouslySetInnerHTML={{ __html: displayBody }} />
        ) : (
          <span>{displayBody}</span>
        )}
        {isWaiting && (
          <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
            <TypingDot delay="0s" />
            <TypingDot delay="0.2s" />
            <TypingDot delay="0.4s" />
          </span>
        )}
      </Typography>
    </StyledMessageContainer>
  );
};

export default MessageContainer;
